
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CurrencyMasterGrid extends Serenity.EntityGrid<CurrencyMasterRow, any> {
        protected getColumnsKey() { return 'OMS.CurrencyMaster'; }
        protected getDialogType() { return CurrencyMasterDialog; }
        protected getIdProperty() { return CurrencyMasterRow.idProperty; }
        protected getInsertPermission() { return CurrencyMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return CurrencyMasterRow.localTextPrefix; }
        protected getService() { return CurrencyMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}